import { render, staticRenderFns } from "./ManageCohortsTable.vue?vue&type=template&id=44716bef"
import script from "./ManageCohortsTable.vue?vue&type=script&lang=js"
export * from "./ManageCohortsTable.vue?vue&type=script&lang=js"
import style0 from "./ManageCohortsTable.vue?vue&type=style&index=0&id=44716bef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports